import "./Stepper.css";
import { Check } from "./icons";

// A numbered workflow stepper. steps: [{ key, label, description? }].
// current: the key shown now. isDone(key) / isReachable(key): completed steps get a check mark;
// reachable steps other than the current one are buttons (onSelect(key)), the rest plain text.
export default function Stepper({ steps = [], current, isDone = () => false, isReachable = () => false, onSelect, label, className = "" }) {
  const currentIndex = steps.findIndex((step) => step.key === current);
  return (
    <nav className={`ui-stepper ${className}`} aria-label={label}>
      <ol className="ui-stepper__list">
        {steps.map((step, index) => {
          const active = step.key === current;
          const done = !active && isDone(step.key);
          const clickable = !active && Boolean(onSelect) && isReachable(step.key);
          const state = active ? "is-current" : done ? "is-done" : index < currentIndex ? "is-passed" : "is-upcoming";
          const content = (
            <>
              <span className="ui-stepper__marker" aria-hidden="true">{done ? <Check size={15} strokeWidth={3} /> : index + 1}</span>
              <span className="ui-stepper__text">
                <span className="ui-stepper__label">{step.label}</span>
                {step.description && <span className="ui-stepper__description">{step.description}</span>}
              </span>
            </>
          );
          return (
            <li key={step.key} className={`ui-stepper__item ${state}`} aria-current={active ? "step" : undefined} data-step={step.key}>
              {clickable ? (
                <button type="button" className="ui-stepper__button" onClick={() => onSelect(step.key)}>{content}</button>
              ) : (
                <span className="ui-stepper__button" aria-disabled={!active || undefined}>{content}</span>
              )}
            </li>
          );
        })}
      </ol>
    </nav>
  );
}
